// Appels HTTP typés vers /api/reminder-rules/* (Lot 4C — UI admin).
//
// 3 règles sont seedées à la création du tenant (J+7, J+14, J+30). Cette
// API permet à un admin d'en créer / modifier / supprimer librement.

import { api } from "./client";
import type {
  ReminderRuleCreate,
  ReminderRulePublic,
  ReminderRuleUpdate,
  UUID,
} from "./types";

export const reminderRulesApi = {
  list: () => api.get<ReminderRulePublic[]>("/api/reminder-rules"),

  create: (payload: ReminderRuleCreate) =>
    api.post<ReminderRulePublic>("/api/reminder-rules", payload),

  update: (id: UUID, payload: ReminderRuleUpdate) =>
    api.patch<ReminderRulePublic>(`/api/reminder-rules/${id}`, payload),

  delete: (id: UUID) => api.delete<void>(`/api/reminder-rules/${id}`),
};
